import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Donations() {
  const { t } = useTranslation();
  return (
    <div className="relative min-h-[100svh] bg-zinc-950 flex items-center justify-center pt-4 lg:pt-8 pb-20 px-6 sm:px-12 lg:px-20 overflow-hidden">
      {/* Cinematic Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-40 mix-blend-luminosity bg-fixed"
        style={{ backgroundImage: "url('/assets/hero/ElSeminario.webp')" }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/90 to-zinc-950/40"></div>
      
      {/* Content Container */}
      <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-8">
        
        {/* Left: Inspiring Typography */}
        <div className="flex-1 text-center lg:text-left max-w-2xl lg:pr-10">
          <h1 className="font-neocat text-4xl md:text-6xl lg:text-7xl text-white mb-6 md:mb-8 tracking-widest drop-shadow-xl uppercase">
            {t("epayco.title")}
          </h1>
          <div className="w-16 md:w-24 h-[2px] bg-zinc-500 mx-auto lg:mx-0 mb-8 md:mb-12"></div>
          
          <p className="font-neocat text-lg md:text-3xl text-zinc-200 leading-relaxed font-light mb-8 lg:mb-10">
            {t("epayco.subtitle")}
          </p>
          
          <p className="text-zinc-400 font-sans text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 font-light border-l border-zinc-700 pl-4 lg:pl-6">
            {t("epayco.description")}
          </p>
        </div>

        {/* Right: Elegant Donation Card */}
        <div className="w-full max-w-[460px] bg-white rounded-sm shadow-2xl text-zinc-900 flex flex-col relative overflow-hidden group">
          {/* Card Header */}
          <div className="p-10 md:p-12 pb-8 text-center bg-zinc-50 border-b border-zinc-200">
            <h2 className="font-neocat text-2xl font-bold mb-2 tracking-wide text-zinc-950">{t("epayco.card_title")}</h2>
            <p className="text-zinc-500 text-xs tracking-[0.3em] uppercase">{t("epayco.card_subtitle")}</p>
          </div>
          
          {/* Card Body */}
          <div className="p-10 md:p-12 space-y-8 bg-white">
            
            {/* Currencies */}
            <div className="flex justify-between items-end border-b border-zinc-100 pb-4">
              <span className="text-zinc-400 font-sans text-xs uppercase tracking-widest">{t("epayco.currencies")}</span>
              <span className="font-neocat font-bold text-zinc-900 tracking-wider">COP / USD</span>
            </div>
            
            {/* Processor */}
            <div className="flex justify-between items-end border-b border-zinc-100 pb-4">
              <span className="text-zinc-400 font-sans text-xs uppercase tracking-widest">{t("epayco.platform")}</span>
              <img src="/logoEpayco.png" alt="ePayco" className="h-5 object-contain" width="80" height="20" loading="lazy" />
            </div>
            
            {/* Payment Methods (Robust SVGs) */}
            <div className="pt-2 flex flex-col gap-5">
               <span className="text-zinc-400 font-sans text-[10px] uppercase tracking-widest text-center">{t("epayco.secure_payment_methods")}</span>
               <div className="flex justify-center items-center gap-6 md:gap-8 mt-2">
                 <img src="/logoVISA.png" alt="Visa" className="h-4 md:h-6 w-auto object-contain hover:scale-105 transition-transform drop-shadow-sm" width="60" height="24" loading="lazy" />
                 <img src="/MastercardLogo.png" alt="Mastercard" className="h-7 md:h-9 w-auto object-contain hover:scale-105 transition-transform drop-shadow-sm" width="60" height="36" loading="lazy" />
                 <img src="/americanExpressLogo.png" alt="American Express" className="h-9 md:h-11 w-auto object-contain hover:scale-105 transition-transform drop-shadow-sm" width="60" height="44" loading="lazy" />
                 <img src="/logPSE.png" alt="PSE" className="h-9 md:h-11 w-auto object-contain hover:scale-105 transition-transform drop-shadow-sm" width="44" height="44" loading="lazy" />
               </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full p-4 md:p-6 bg-zinc-50 border-t border-zinc-100">
            <a 
              href="https://panel.epayco.co/checkoutopen/7d6c4137-7913-4535-a915-aa57a8f928c0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 py-4 bg-zinc-950 text-white font-neocat font-bold tracking-[0.1em] uppercase text-xs text-center flex flex-col items-center justify-center gap-1 hover:bg-zinc-800 transition-all shadow-lg hover:-translate-y-1 rounded-sm"
            >
              <span>Donar vía</span>
              <img src="/logoEpayco.png" alt="ePayco" className="h-4 object-contain opacity-90 invert mt-1" />
            </a>
            
            <Link 
              to="/donacion"
              className="flex-1 py-4 bg-white text-zinc-950 border border-zinc-300 font-neocat font-bold tracking-[0.1em] uppercase text-xs text-center flex flex-col items-center justify-center gap-1 hover:bg-zinc-100 transition-all shadow-lg hover:-translate-y-1 rounded-sm"
            >
              <span>Donar vía</span>
              <span className="font-sans font-black tracking-tighter mt-1 opacity-80 text-sm">PlaceToPay</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
